import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import HeroSection from "../../components/Landingpage/HeroSection";
import LanguageSlider from "../../components/Landingpage/LangSlider";
import CoursesSection from "../../components/Landingpage/CoursesSection";
import StatsSection from "../../components/Landingpage/StatsSection";
import InstructorsSection from "../../components/Landingpage/InstructorsSection";
import Footer from "../../components/Landingpage/Footer";
import Navbar from "../../components/Landingpage/Navbar";
import BlueSocial from "../../components/Landingpage/BlueSocial";
import MethodologySection from "../../components/Landingpage/MethodologySection";
import TestimonialsSection from "../../components/Landingpage/TestimonialsSection";
import FaqSection from "../../components/Landingpage/FaqSection";
import CtaSection from "../../components/Landingpage/CtaSection";
import AboutSection from "../../components/Landingpage/AboutSection";
import ContactSection from "../../components/Landingpage/ContactSection";
import DesignCredit from "../../components/Landingpage/DesignCredit";
import PlacementTestSection from "../../components/Landingpage/PlacementTestSection";

const LandingMain = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button when user scrolls down 300px from the top
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col min-h-screen"
      >
        <BlueSocial />
        <Navbar />
        <HeroSection />
        <LanguageSlider />
        <MethodologySection /> 
        <CoursesSection />
        <PlacementTestSection />
        <TestimonialsSection />
        <StatsSection />
        <InstructorsSection />
        <FaqSection />
        <CtaSection />
        <AboutSection />
        <ContactSection />
        <Footer />
        {/* <DesignCredit /> */}
        {/* Floating Scroll to Top Button */}
        <AnimatePresence>
          {showScrollButton && (
            <motion.button
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5 }}
              transition={{ duration: 0.3 }}
              onClick={scrollToTop}
              className="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-primary text-white shadow-lg flex items-center justify-center hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 z-50"
              aria-label="Scroll to top"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 10l7-7m0 0l7 7m-7-7v18"
                />
              </svg>
            </motion.button>
          )}
        </AnimatePresence>
      </motion.div>
    </AnimatePresence>
  );
};

export default LandingMain;
